import { FC } from 'react';

import { Spinner, SpinnerProps } from '@chakra-ui/react';

export const LoadingSpinner: FC<SpinnerProps> = (props) => {
  return <Spinner thickness="4px" speed="0.65s" emptyColor="violet.100" color="violet.400" size="xl" {...props} />;
};
